import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../context/AppContext';
import { getUnreadCount } from 'utils/apis/conversation';

export const useSocket = (enabled = true) => {
  const { socket, isSocketConnected, checkIsAdmin, checkAllowViewAllChats, user } = useContext(AppContext);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);

  const fetchUnreadCount = async () => {
    try {
      const isAdmin = checkIsAdmin();
      const hostId = isAdmin ? null : user && user.roles && user.roles[0] && user.roles[0].host;
      const canViewAllChats = await checkAllowViewAllChats();
      const response = await getUnreadCount(hostId, canViewAllChats);
      console.log(response, 'response in fetchUnreadCount');
      if (response && response.totalUnifiedUnreadCount !== undefined) {
        setUnreadMessageCount(response.totalUnifiedUnreadCount);
        console.log('Unread messages fetched:', response.totalUnifiedUnreadCount);
      }
    } catch (error) {
      console.error('Error fetching unread count:', error);
    }
  };

  useEffect(() => {
    if (!enabled) return;
    console.log(socket, isSocketConnected, user, 88);
    if (socket && isSocketConnected && user) {
      fetchUnreadCount();

      socket.on('refreshUnreadMessageCount-nebula', () => {
        console.log('Socket event received: refreshUnreadMessageCount-nebula');
        fetchUnreadCount();
      });
      socket.on('afterRead', () => {
        console.log('Socket event received: afterRead');
        fetchUnreadCount();
      });

      return () => {
        socket.off('refreshUnreadMessageCount-nebula');
        socket.off('afterRead');
      };
    }
  }, [socket, isSocketConnected, user, checkIsAdmin, checkAllowViewAllChats, enabled]);

  return { unreadMessageCount, socket, isSocketConnected };
};
